import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class InterogariPlatiService {
    private token!: string;
    private basePath = environment.interop.basePath;
    private httpOptions: any;

    public downloadDocumentPlataUrl =
        this.basePath +
        environment.interop.payments.nomenclatoare.interogariPlati.downloadDocumentPlata;

    constructor(private http: HttpClient) { }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
